<div class="field-management-table-block table-boundary ">
  <table mat-table #reorderTable [dataSource]="dataSource" class="mat-elevation-z8" cdkDropList
    [cdkDropListData]="dataSource" (cdkDropListDropped)="dropTable($event)" matSort cdkDragBoundary=".table-boundary"
    #empTbSort="matSort" (matSortChange)="sortData()">

    <ng-container [matColumnDef]="col.key" *ngFor="let col of columns">
      <th mat-header-cell *matHeaderCellDef [style.width]="col?.width" [style.textAlign]="col?.align"
        [style.paddingLeft]="col?.paddingLeft">{{col?.label}}
      </th>
      <ng-container *ngIf="col.key == 'position'">
        <td mat-cell *matCellDef="let element" [style.width]="col?.width" [style.textAlign]="col?.align"
          [style.paddingLeft]="col?.paddingLeft">
          <mat-icon *ngIf="element?.isReorder" style="pointer-events: all;" class="reorder-class"
            cdkDragHandle>reorder</mat-icon>
        </td>
      </ng-container>
      <ng-container *ngIf="col.key == 'Action'">
        <td mat-cell style="pointer-events: none;" [style.width]="col?.width" *matCellDef="let element"
          [style.textAlign]="col?.align" [style.paddingLeft]="col?.paddingLeft">
          <button mat-icon-button (click)="editField(element)" title="Click to Edit">
            <mat-icon class="actionItems excelandinfo-Icon-font"
              style="font-size: 1.1rem !important; cursor: pointer; color: #013B71; margin-top: 3px !important; pointer-events: all !important;">
              create
            </mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container *ngIf="col.key == 'input_type'">
        <td mat-cell style="pointer-events: none;" *matCellDef="let element" [style.width]="col?.width"
          [style.paddingLeft]="col?.paddingLeft" [style.textAlign]="col?.align">
          {{element[col.key]}} <span *ngIf="element[col.key] == 'input'">- {{element['data_type']}}</span><span
            *ngIf="!(element[col.key] == 'input' && (element['data_type'] == 'int' || element['data_type'] == 'float'))">
            ({{element['length']}})</span>
        </td>
      </ng-container>

      <ng-container *ngIf="col.key == 'currentOrder'">
        <td mat-cell style="pointer-events: none;" *matCellDef="let element;let i = index" [style.width]="col?.width"
          [style.paddingLeft]="col?.paddingLeft" [style.textAlign]="col?.align">
          {{i + 1 + (paginator.pageIndex * paginator.pageSize)}}
        </td>
      </ng-container>
      <ng-container *ngIf="col.key == 'allowed_values'">
        <td mat-cell style="pointer-events: none;" *matCellDef="let element" [style.width]="col?.width"
          [style.paddingLeft]="col?.paddingLeft" [style.textAlign]="col?.align">
          <div class="scroll-content">
            <table>
              <tbody>
                <tr *ngFor="let option of element.allowed_values">
                  <td>
                    {{ option }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </ng-container>
      <ng-container *ngIf="col.key == 'Edit_Roles'">
        <td mat-cell style="pointer-events: none;" *matCellDef="let element" [style.width]="col?.width"
          [style.paddingLeft]="col?.paddingLeft" [style.textAlign]="col?.align">
          <div class="scroll-content">
            <table>
              <tbody>
                <tr *ngFor="let option of element.Edit_Roles">
                  <td>
                    {{ option }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </ng-container>
      <ng-container>
        *ngIf="!(col.key == 'Edit_Roles'|| col.key == 'currentOrder' || col?.key == 'position' || col?.key ==
        'allowed_values' || col?.key == 'input_type' || col?.key == 'Action')">
        <td mat-cell style="pointer-events: none;" *matCellDef="let element" [style.width]="col?.width"
          [style.paddingLeft]="col?.paddingLeft" [style.textAlign]="col?.align">
          {{element[col.key]}}
        </td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"
      [cdkDragDisabled]="!(systemAdmin || admin)" class="table-row"></tr>
  </table>
  <ng-container>
    <mat-paginator #paginator [length]="dataSource?.data?.length" [pageSizeOptions]="[10,20,30]" showFirstLastButtons>
    </mat-paginator>
  </ng-container>
</div>

<app-modal [maximizable]="true" #editFieldPopUp class="modal-demo enable-field-popup" (closeModal)="closemodal()">
  <ng-container class="app-modal-header">Edit Field ({{type}})</ng-container>
  <ng-container class="app-modal-body ">
    <app-enable-field-popup [clearFormFields]="clearFormFields" [editRolesOptions]="editRolesOptions" [isEdit]="isEdit"
      [currentFieldData]="currentIndexData" [categories]="categories" [initiativeId]="initiativeId"
      [columns]="currentColumns" [isVisibleFieldDisabled]="isVisibleFieldDisabled"
      (emitReqPayload)="submitEnableField($event)" [fieldData]="fieldDataArr">
    </app-enable-field-popup>
  </ng-container>
</app-modal>